import React, { Component } from "react";
import { Card } from "react-bootstrap";
import secure from "../../assets/secure.png";
import "../../../node_modules/video-react/dist/video-react.css";
import pdfFile from "../../assets/pdf/PMG_Security_Features.pdf";

export class CreateProjectSidebar extends Component {
  render() {
    return (
      <React.Fragment>
        {/*<Card className="video-card sidebar-card">
          <Player
            playsInline
            poster={Poster}
            src=""
            // src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
          />
          <Card.Body>
            <Card.Title className="video-title">
              Best Practice to add projects & issues
            </Card.Title>
          </Card.Body>
        </Card>*/}
        <a
          href={pdfFile}
          type="application/pdf"
          target="_blank"
          className="secure-card-wrapper"
        >
          <Card className="secure-card sidebar-card">
            <Card.Img variant="top" src={secure} className="secure-img" />
            <Card.Body>
              <Card.Title className="secure secure-title">
                Secure Information
              </Card.Title>
              <Card.Text className="secure secure-text">
                All information provided will remain with the Ministry/State/PMG
                officials. No information will be disclosed publicly.
              </Card.Text>
            </Card.Body>
          </Card>
        </a>
        {/*<Card className="sidebar-card help-block">
          <Card.Img variant="top" src={help} className="need-help-img" />
          <Card.Body>
            <Card.Title className="help need-help-title1">
              Need Help? Call Us
            </Card.Title>
            <Card.Title className="help need-help-title2">
              1800-243-334
            </Card.Title>
            <Card.Text className="help need-help-text">
              Need any type of help for filling this form Please call us we
              would love to hear from you and resolve your query
            </Card.Text>
          </Card.Body>
        </Card>
        <Card className="good-submissions sidebar-card">
          <Card.Body className="good-submissions-body">
            <Card.Title className="good-submissions-title">
              Examples of Good Submissions
            </Card.Title>
            <Card.Text className="good-submissions-text">
              Do you know 25% Issues rejects or taken longer time to resolved
              due to bad submission
            </Card.Text>
            <Button className="submissions-btn">View Good Example</Button>
          </Card.Body>
        </Card>*/}
      </React.Fragment>
    );
  }
}

export default CreateProjectSidebar;
